import { PropsWithClassName, PropsWithId } from '~types/Props.types';

export enum BreadCrumbsMod {
  Gray = 'gray',
  White = 'white',
}

export type BreadCrumbsLink = PropsWithId<{
  title: string;
  href?: string;
}>;

export type BreadCrumbsProps = PropsWithClassName<{
  links: BreadCrumbsLink[];
  mod?: BreadCrumbsMod;
}>;
